<template>
  <div class="d-flex align-items-center reaction-wrapper">
    <emoji-picker @select="postReaction" @shown="$emit('ep-shown')" @hidden="$emit('ep-hidden')">
      <i class="like-icon pointer" :id="'like-' + uuid"></i>
    </emoji-picker>
    <tooltip :target="'like-' + uuid">React</tooltip>
  </div>
</template>

<script>
import EmojiPicker from '@/components/reactions/EmojiPicker'
import Tooltip from '@/components/Tooltip'
import { EVENT_ACTION } from '@/constants/analytics'
import { EVENT_OTYPE } from '@/constants/awards'
import ComponentIdMixin from '@/mixins/ComponentIdMixin'
import service from '@/service'
import urlManager from '@/urlManager'
import showAPIError from '@/utils/showAPIError'
import trackEventActivity from '@/utils/trackEventActivity'
import unicodeToEmoji from '@/utils/unicodeToEmoji'

/**
 * This renders an icon (thumbs up icon), click of which opens the emoji picker to select emoji from
 *
 * @emits
 * - reacted
 * - ep-shown: is triggered when emoji picker(popover) is shown
 * - ep-hidden: is triggered when emoji picker(popover) is hidden
 */
export default {
  name: 'PostReactionIcon',
  props: {
    event: Object,
    teamName: String
  },
  mixins: [ComponentIdMixin],
  components: {
    EmojiPicker,
    Tooltip
  },
  methods: {
    getReactionUrl() {
      const { goalId, id: eventId, organizationId, initiativeId } = this.event
      if (this.event.otype === EVENT_OTYPE.GOAL_EVENT) {
        return urlManager.goalEventDetails({ orgId: organizationId, goalId, eventId })
      } else if (this.event.otype === EVENT_OTYPE.INITIATIVE_EVENT) {
        return urlManager.initiativeEventDetails({ orgId: organizationId, initiativeId, eventId })
      }
    },
    async postReaction(unicode) {
      const url = this.getReactionUrl()
      try {
        const response = await service.client.post(url, {
          action: 'react',
          reaction_type: unicodeToEmoji(unicode)
        })
        trackEventActivity(this.event, EVENT_ACTION.REACT)
        this.$emit('reacted', response.data)
      } catch (e) {
        showAPIError(e)
      }
    }
  }
}
</script>
